import { type AnyAction, combineReducers } from 'redux';
import Immutable from 'immutable';

import type { SlideTranslatedText, SupportedLanguages } from 'js/src/client';
import StoreORM from 'js/src/data/store-orm';
import {
    storeLoadingSupportedLanguages,
    storeSupportedLanguages,
    storeVideoTranslations,
} from 'js/src/data/translations/translations-actions';
import type { ImmutableMap } from 'js/src/libs/consts';

export function translations(
    state = StoreORM.newFromIdPrefix<SlideTranslatedText, string>('translations').data,
    action: AnyAction,
) {
    if (storeVideoTranslations.match(action)) {
        const orm = new StoreORM<SlideTranslatedText, string>(state);
        action.payload.translations.forEach((translation) => {
            orm.pushJSItem(
                {
                    slide_id: translation.get('slide_id'),
                    message: translation.get('message'),
                },
                'slide_id',
            );
        });
        return orm.data;
    }
    return state;
}

export function supported_languages(
    state = Immutable.List<ImmutableMap<SupportedLanguages>>(),
    action: AnyAction,
) {
    if (storeSupportedLanguages.match(action)) {
        return action.payload.supported_languages;
    }
    return state;
}

export function is_loading_supported_languages(state = false, action: AnyAction) {
    if (storeLoadingSupportedLanguages.match(action)) {
        return action.payload.is_loading;
    }
    return state;
}

export const translationsReducer = combineReducers({
    translations,
    supported_languages,
    is_loading_supported_languages,
});

export type TranslationsState = ReturnType<typeof translationsReducer>;
